import { Ref, ref, computed } from "vue";
import { KoyouKeiyakuTimeAndHayabanOsobanOption, KoyouKeiyakuTimeAndHayabanOsobanOptions } from "@/types/KoyouKeiyakuTime";
import dayjs from "dayjs";
import { howWeek } from "@/filters/common";
import { Logger } from "@/utils/Logger";

/*
 * セレクトボックス用オプション処理
 */
export function useWrokTimeOptions() {

  const getOptionForTimeAndHayabanOsoban = async (date: string | Date | null, selectOpt: Ref<KoyouKeiyakuTimeAndHayabanOsobanOption | null>, options: Ref<KoyouKeiyakuTimeAndHayabanOsobanOptions>) => {
    if(!date){
      selectOpt.value = null
      return []
    }
    
    const d = dayjs(date)

    // 指定した日付がシフト勤務の中にあるか
    let opt = options.value.hayabanOsobanOpt.filter(function(v, k){
      return d.isSame(v.date)
    })
    if(opt.length > 0){
      selectOpt.value = opt[0]
      return opt
    }
    
    // 指定した日付の曜日が雇用契約時間にあるか
    const youbiNum = d.day()
    const weeks = howWeek(date) ?? -1
    opt = options.value.koyouKeiyakuTimeOpt.filter(function(v, k){
      Logger.debug('雇用契約に含まれる週番号（koyou_keiyaku_times.weeks）', v.weeks)
      if(v.weeks && v.weeks.indexOf(weeks.toString()) < 0 ){
        return false
      }
      return v.youbiNum.indexOf(youbiNum) >= 0
    })
    if(opt.length > 0){
      selectOpt.value = opt[0]
      return opt
    }else{
      selectOpt.value = null
      return []
    }
  }

  return {
    getOptionForTimeAndHayabanOsoban,
  }
}
